import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    additionalPaymentStatusState: '',
    jobIdState: '',
    fromDateState: '',
    toDateState: '',
    clearFilterFlag: 0
}

const AdditionalPaymentFilterSlice = createSlice({
    name: 'additionalPaymentFilter',
    initialState,
    reducers: {
        setAdditionalpaymentStatus(state, action) {
            state.additionalPaymentStatusState = action.payload;
        },
        setJobId(state, action) {
            state.jobIdState = action.payload;
        },
        setFromDate(state, action) {
            state.fromDateState = action.payload;
        },
        setToDate(state, action) {
            state.toDateState = action.payload;
        },
        setClearFilterFlag(state, action) {
            state.clearFilterFlag = action.payload;
        },
        reset(state) {
            state.additionalPaymentStatusState = '';
            state.jobIdState = '';
            state.fromDateState = '';
            state.clearFilterFlag = 0;
            state.toDateState = '';
        }
    }
});

export const { setAdditionalpaymentStatus, setJobId, setFromDate, setToDate, setClearFilterFlag, reset  } = AdditionalPaymentFilterSlice.actions;

export default AdditionalPaymentFilterSlice.reducer;